import {ShiftEvent, useApprovalAffiliate} from '@domain/shifthandover'
import {MAX_ALLOWED_ATTACHMENTS} from '@hconnect/common/consts'
import {headlineSx, imageBoxSx} from '@hconnect/common/styles'
import {getUniqueAttachments} from '@hconnect/common/utils'
import {CardSectionTitle} from '@hconnect/uikit/src/lib2'
import {useUpmPlant} from '@hconnect/upm'
import {usePermission} from '@hproduce/permissions'
import {Box, Divider, Grid} from '@mui/material'
import {AttachmentItem, AttachmentItemsDisplay} from '@widgets/common-attachments'
import {EventDetails, Comments} from '@widgets/shift-event-details'
import {FC, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type EventContentProps = {
  event: ShiftEvent
  plantId: string
}

export const EventContent: FC<EventContentProps> = ({event, plantId}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {country} = useUpmPlant({plantId})
  const plantContext = {plantId, countryId: country}
  const allowedToViewDocuments = usePermission({
    plantContext,
    permissionTypes: ['VIEW_DOCUMENTS']
  })
  const [activeAttachmentId, setActiveAttachmentId] = useState<number | undefined>(undefined)

  const uniqueAttachments = getUniqueAttachments(event?.attachments, MAX_ALLOWED_ATTACHMENTS)

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} sm={10} md={8} lg={6} xl={4}>
        <EventDetails
          disableStatus
          disableConfig
          item={event}
          plantId={plantId}
          useApprovalHook={useApprovalAffiliate}
          data-test-id="page-events-details"
        >
          {allowedToViewDocuments && uniqueAttachments && (
            <>
              <CardSectionTitle sx={headlineSx()}>
                {t('shiftEventsAffiliates.label.attachments')}{' '}
                {`${uniqueAttachments.length}/${MAX_ALLOWED_ATTACHMENTS}`}
              </CardSectionTitle>
              <Divider sx={{borderColor: 'divider'}} />
              <Box component="span" sx={imageBoxSx()}>
                {uniqueAttachments.map((attachment, index) => (
                  <AttachmentItem
                    key={`attachment-${attachment.id}`}
                    attachment={attachment}
                    setActiveAttachmentId={setActiveAttachmentId}
                    disableError={activeAttachmentId !== undefined || !!index}
                  />
                ))}
              </Box>
            </>
          )}

          <Comments hideAddComments eventId={event.id} plantId={plantId} country={country} />
          {activeAttachmentId !== undefined && (
            <AttachmentItemsDisplay
              attachments={uniqueAttachments}
              activeAttachmentId={activeAttachmentId}
              onClose={() => setActiveAttachmentId(undefined)}
            />
          )}
        </EventDetails>
      </Grid>
    </Grid>
  )
}
